import { Sparkles } from "lucide-react";
import { waLink, WA_MESSAGES, trackWhatsApp } from "@/lib/whatsapp";
import Reveal from "./Reveal";
import WhatsAppIcon from "./WhatsAppIcon";

export default function CustomTour() {
  return (
    <section className="mx-auto max-w-7xl px-5 pb-24 sm:px-8 sm:pb-32" data-testid="custom-tour-section">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-amber-400/25 bg-gradient-to-br from-[#1E2631] to-[#11161D] p-10 sm:p-16">
          <img
            src="/images/arcos-lapa.jpg"
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="absolute inset-0 h-full w-full object-cover opacity-15"
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(ellipse 50% 60% at 85% 20%, rgba(245,158,11,0.12), transparent 70%)",
            }}
          />
          <div className="relative">
            <p className="flex items-center gap-2 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
              <Sparkles className="h-4 w-4" />
              Roteiro personalizado
            </p>
            <h2 className="mt-5 max-w-2xl font-display text-3xl font-extrabold leading-tight tracking-tight text-stone-50 sm:text-4xl lg:text-5xl">
              Quer conhecer o Rio{" "}
              <em className="font-accent font-medium italic text-amber-400">do seu jeito?</em>
            </h2>
            <p className="mt-6 max-w-xl text-base leading-relaxed text-stone-300 sm:text-lg">
              Nem todo viajante quer conhecer o Rio da mesma forma. Conte o que você
              gostaria de conhecer, quanto tempo tem disponível e o que combina com
              você. Eu monto uma experiência personalizada, respeitando seu ritmo e
              seus interesses.
            </p>
            <a
              href={waLink(WA_MESSAGES.custom)}
              onClick={() => trackWhatsApp("roteiro_personalizado", "Roteiro Personalizado")}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="tour-cta-custom"
              className="mt-9 inline-flex items-center gap-3 rounded-full bg-[#25D366] px-8 py-4 text-sm font-bold uppercase tracking-wider text-white shadow-[0_0_40px_rgba(37,211,102,0.3)] transition-[background-color,transform] duration-300 hover:scale-[1.03] hover:bg-[#20BD5A]"
            >
              <WhatsAppIcon className="h-5 w-5" />
              Montar meu roteiro
            </a>
          </div>
        </div>
      </Reveal>
    </section>
  );
}
